import React from "react";
import FieldBox from "../../../utils/Form/ui/FieldBox";

const FieldBoxComponent = () => {
  return (
    <div className="mt-6">
      <p className="font-bold text-sm">불량접수 정보</p>
      <div className="flex mt-4 items-center">
        <div className="w-1/2">
          <FieldBox splitted label="접수번호">
            <span className="p-2">O20220501-005-04</span>
          </FieldBox>
        </div>
        <div className="w-1/2">
          <FieldBox splitted label="주문구분">
            <span className="p-2">불량접수</span>
          </FieldBox>
        </div>
      </div>
      <div className="flex items-center">
        <div className="w-1/2">
          <FieldBox splitted label="접수일시">
            <span className="p-2">2022-09-15 23:59</span>
          </FieldBox>
        </div>
        <div className="w-1/2">
          <FieldBox splitted label="주문자">
            <span className="p-2">원데이치과 (test123@gmail.com)</span>
          </FieldBox>
        </div>
      </div>
      <div className="flex items-center">
        <div className="w-1/2">
          <FieldBox splitted label="상품 결제일시">
            <span className="p-2">2022-01-01 23:59:59</span>
          </FieldBox>
        </div>
        <div className="w-1/2">
          <FieldBox splitted label="접수 수량">
            <span className="p-2">3</span>
          </FieldBox>
        </div>
      </div>
      <div className="flex items-center">
        <div className="w-1/2">
          <FieldBox splitted label="대표자 연락처">
            <span className="p-2">010123445678</span>
          </FieldBox>
        </div>
        <div className="w-1/2">
          <FieldBox splitted label="담당자 연락처">
            <span className="p-2">010123445678</span>
          </FieldBox>
        </div>
      </div>
      <div className="flex items-center">
        <div className="w-1/2">
          <FieldBox splitted isLast label="전화번호">
            <span className="p-2">010123445678</span>
          </FieldBox>
        </div>
        <div className="w-1/2">
          <FieldBox splitted isLast label="배송지">
            <span className="p-2">
              (07326) 서울 영등포구 국제금융로 10 IFC Three 18층
            </span>
          </FieldBox>
        </div>
      </div>
    </div>
  );
};

export default FieldBoxComponent;
